import carrierZoneModule from "./carrierZoneModule"

carrierZoneModule.service("carrierZoneBaseController", ["$timeout", "messagesModal", "entityEditionService", "regionImportModal", ($timeout, messagesModal, entityEditionService, regionImportModal) => {
    return (entityType, $scope, sourceEntity, entity) => {
        const updateService = entityEditionService.crudHelper(entityType, sourceEntity)
        $scope.entity = entity
        $scope.entityType = entityType

        let polygonsHereApi = null
        $scope.onRegisterHereApi = (api) => {
            polygonsHereApi = api
        }

        $scope.openImportModal = function () {
            polygonsHereApi.getPolygons()
            regionImportModal().then(function (polygons) {
                if (polygons) {
                    polygons.editable = false
                    polygonsHereApi.addPolygons({
                        polygons: polygons
                    })
                    polygonsHereApi.centerMapOnPolygon()
                }
            })
        }

        $scope.importJSON = function () {
            const input = createInputElement()
            input.addEventListener("change", () => {
                try {
                    if (input.files && input.files.length > 0) {
                        const file = input.files[0]
                        if (file) {
                            validateIfIsJsonFile(file)
                            const reader = createReaderWithPolygons()
                            reader.readAsText(file)
                        }
                    }
                } catch (e) {
                    messagesModal("dialog.error", e.message)
                }
            })
            input.click()
        }

        function createInputElement() {
            const input = document.createElement("input")
            input.type = "file"
            input.accept = ".json"
            return input
        }

        function validateIfIsJsonFile(file) {
            if (file.type !== "application/json") {
                throw new Error("edition.carrierZone.invalid.type.error")
            }
        }

        function createReaderWithPolygons() {
            const reader = new FileReader()
            reader.onload = function (e) {
                $scope.$apply(function () {
                    try {
                        const newPolygonsToBeAdded = []
                        const polygonsThatAreAlreadyOnTheMap = polygonsHereApi.getPolygons()
                        const polygons = JSON.parse(e.target.result)
                        polygons.forEach(jsonPolygon => {
                            if (!polygonExists(jsonPolygon, polygonsThatAreAlreadyOnTheMap)) {
                                validatePolygonsToImport(jsonPolygon)
                                jsonPolygon.editable = false
                                newPolygonsToBeAdded.push(jsonPolygon)
                            }
                        })
                        addPolygonsOnMap(newPolygonsToBeAdded)
                    } catch (e) {
                        messagesModal("dialog.error", e.message)
                    }
                })
            }
            return reader
        }

        function polygonExists(polygon, polygonsThatAreAlreadyOnTheMap) {
            return polygonsThatAreAlreadyOnTheMap.some(polygonOnTheMap => {
                return JSON.stringify(polygon.points) === JSON.stringify(polygonOnTheMap.points)
            })
        }

        function validatePolygonsToImport(polygon) {
            const points = polygon.points
            validateIfIsPossibleToDrawThePolygon(points)
            validateLatLong(points)
        }

        function validateIfIsPossibleToDrawThePolygon(points) {
            if (points && points.length < 3) {
                throw new Error("edition.carrierZone.invalid.polygon.error")
            }
        }

        function validateLatLong(points) {
            return points.forEach(point => {
                if (typeof point.lat !== "number" || typeof point.lng !== "number") {
                    throw new Error("edition.carrierZone.lat.long.is.not.number.error")
                }

                if (point.lat < -90 || point.lat > 90) {
                    throw new Error("edition.carrierZone.invalid.lat.error")
                }

                if (point.lng < -180 || point.lng > 180) {
                    throw new Error("edition.carrierZone.invalid.long.error")
                }
            })
        }

        function addPolygonsOnMap(newPolygonsToBeAdded) {
            if (newPolygonsToBeAdded.length === 0) {
                throw new Error("edition.carrierZone.equal.polygons.error")
            }
            polygonsHereApi.addPolygons({
                polygons: newPolygonsToBeAdded
            })
            polygonsHereApi.centerMapOnPolygon()
        }

        $scope.exportJSON = function () {
            try {
                const polygons = polygonsHereApi.getPolygons()
                validatePolygons(polygons)
                const jsonPolygons = JSON.stringify(removeEditableFromPolygons(polygons))
                let element = createElement(jsonPolygons)
                document.body.appendChild(element)
                $timeout(function () {
                    element.click()
                    document.body.removeChild(element)
                }, 0)
            } catch (e) {
                messagesModal("dialog.error", e.message)
            }
        }

        function validatePolygons(polygons) {
            if (polygons.length === 0) {
                throw new Error("edition.carrierZone.empty.export.error")
            }
        }

        function removeEditableFromPolygons(polygons) {
            polygons.forEach(polygon => {
                delete polygon["editable"]
            })
            return polygons
        }

        function createElement(jsonPolygons) {
            let element = document.createElement("a")
            element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(jsonPolygons))
            element.setAttribute("download", createFileName())
            element.style.display = "none"
            return element
        }

        function createFileName() {
            const entitySourceId = $scope.entity.sourceId
            return entitySourceId ? `${entitySourceId}.json` : "polygons.json"
        }

        $scope.save = () => {
            entity.polygons = polygonsHereApi.getPolygons()
            updateService.save(entity)
        }

        $scope.saveAndContinue = () => {
            entity.polygons = polygonsHereApi.getPolygons()
            updateService.save(entity, true)
        }

    }
}])